<template>
    <div>
        <div class="page-title">
            <h4>{{$t('txt.adaugaSablonOferta')}}</h4>
        </div>
        <form class="add-user-form" id="add-offer-template">
            <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                <div class="inner-location-group">
                    <div class="form-group">
                        <input type="text" class="form-control"
                               v-model="form.name"
                               placeholder=""
                               v-validate="'required'">
                        <label class=""> Nume </label>
                        <span class="focus-input"></span>
                        <span class="symbol-input">
                              <i class="fas fa-signature"></i>
                          </span>
                        <p class="custom-error-info"> {{errors.first('name')}} </p>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-12 form-group">
                <div class="location-header">
                    <h4> {{$t('placeholder.continut')}} </h4>
                </div>
                <div class="inner-location-group form-group">
                    <ckeditor :editor="editor" v-model="form.content" :config="editorConfig"></ckeditor>
                </div>
            </div>
            <div class="col-12">
                <div class="inner-location-group">
                    <div class="save-contact-buttons">
                        <button @click.prevent='addTemplate()' :disabled="this.$store.state.loading">
                            <i class="fas fa-check"></i>
                            {{$t('placeholder.salveaza')}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import OfferTemplatesService from '../../api-services/offer-templates.service.js'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
export default {
  name: 'AddOfferTemplate',
  data () {
    return {
      editor: ClassicEditor,
      editorConfig: {
        // The configuration of the editor.
      },
      form: {
        name: '',
        content: ''
      }
    }
  },
  methods: {
    addTemplate () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('add-offer-template'))
      if (this.form.name) {
        formData.append('name', this.form.name)
      }
      if (this.form.content) {
        formData.append('text', this.form.content)
      }
      // this.adjustLoadingContainer()
      OfferTemplatesService.create(formData)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          if (response.status === 201) {
            this.$notify({
              group: 'succes',
              type: 'success',
              // title: 'Added',
              text: this.$t('success.sablonAdaugat'),
              'animation-type': 'css'
            })
            // var frm = document.getElementById('test-id')
            // alert(frm.offsetTop)
            window.scrollTo(0, 0)
            this.$router.push({ name: 'offer-templates' })
          }
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          if (error.response && typeof error.response.data.error === 'object') {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: this.$t('errors.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }
        })
    }
  },
  computed: {},
  created () {
    this.$store.dispatch('hideLoading')
  }
}
</script>
